export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  likes: number;
  updatedAt: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
}

export interface UserReview {
  id: string;
  userName: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const categories: ComicCategory[] = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事，心动瞬间尽在恋爱漫画' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '穿越异世界，魔法与冒险的奇幻旅程' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血激斗，精彩打斗场面让人目不转睛' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line', description: '扣人心弦的故事情节，深度刻画人物命运' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-happy-line', description: '轻松搞笑的日常喜剧，治愈你的每一天' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '惊险刺激的悬疑推理，层层揭开真相' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '毛骨悚然的恐怖故事，挑战你的胆量极限' },
  { slug: 'slice-of-life', name: '日常', icon: 'ri-home-line', description: '温馨治愈的日常生活，平凡中的不平凡' },
  { slug: 'historical', name: '历史', icon: 'ri-ancient-gate-line', description: '穿越时空的历史故事，感受古代风情' },
  { slug: 'school', name: '校园', icon: 'ri-book-open-line', description: '青春洋溢的校园生活，青涩美好的回忆' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '我的野蛮王妃',
    author: '朴美珍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20beautiful%20princess%20in%20elegant%20hanbok%20dress%2C%20soft%20pastel%20pink%20background%2C%20dreamy%20atmosphere%2C%20romantic%20webtoon%20illustration%2C%20delicate%20lineart%2C%20sparkle%20effects%2C%20manhwa%20cover%20design%20with%20clean%20composition&width=400&height=560&seq=manhwa-cover-01&orientation=portrait',
    description: '一位现代女孩意外穿越到古代朝鲜王朝，成为野蛮王妃。她用自己的智慧和现代思想改变宫廷命运，同时与冷酷的王子展开了一段跌宕起伏的爱情故事。宫廷权谋与浪漫爱情交织，精彩不容错过！',
    category: 'romance',
    tags: ['穿越', '宫廷', '爱情', '权谋'],
    status: '连载中',
    rating: 9.6,
    views: 12580000,
    likes: 892000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `c1-ch${i + 1}`,
      title: i === 0 ? '第1话：命运的相遇' : `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 8)).padStart(2, '0')}-${String(15 - (i % 15)).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-2',
    title: '剑与魔法',
    author: '金俊秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20hero%20holding%20glowing%20sword%20with%20magical%20aura%2C%20dark%20fantasy%20background%20with%20castle%20silhouette%2C%20epic%20adventure%20webtoon%20style%2C%20dramatic%20lighting%2C%20detailed%20armor%20design%2C%20clean%20manhwa%20cover%20composition&width=400&height=560&seq=manhwa-cover-02&orientation=portrait',
    description: '在一个魔法与剑术并存的世界里，少年艾伦从无名小卒成长为传奇剑士。他集结伙伴，对抗黑暗势力，揭开世界隐藏千年的秘密。宏大的世界观，精彩的战斗场面，不容错过的奇幻巨作！',
    category: 'fantasy',
    tags: ['冒险', '魔法', '剑士', '伙伴'],
    status: '连载中',
    rating: 9.5,
    views: 11320000,
    likes: 756000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `c2-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 10)).padStart(2, '0')}-${String(20 - (i % 20)).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '李东旭',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20detective%20in%20dark%20alley%20with%20neon%20lights%2C%20mysterious%20atmosphere%2C%20crime%20noir%20webtoon%20style%2C%20rain%20on%20city%20streets%2C%20dramatic%20shadows%2C%20suspenseful%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-03&orientation=portrait',
    description: '首尔深夜街头，连环案件频发。前刑警金泰浩凭借敏锐直觉追查真相，却发现案件背后隐藏着惊天阴谋。每一页都让人屏息凝神，悬疑氛围拉满！',
    category: 'thriller',
    tags: ['推理', '悬疑', '犯罪', '都市'],
    status: '连载中',
    rating: 9.3,
    views: 8970000,
    likes: 623000,
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 54 }, (_, i) => ({
      id: `c3-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 8)).padStart(2, '0')}-${String(10 + (i % 20)).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: true,
  },
  {
    id: 'comic-4',
    title: '甜蜜陷阱',
    author: '崔秀英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20romance%20cover%2C%20cute%20couple%20in%20cafe%20setting%2C%20warm%20pastel%20colors%2C%20sweet%20romantic%20webtoon%20illustration%2C%20coffee%20shop%20background%2C%20light%20and%20fluffy%20atmosphere%2C%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-04&orientation=portrait',
    description: '咖啡店老板与神秘顾客之间的甜蜜拉锯战！以为是普通客人，却发现对方是自己失散多年的青梅竹马。搞笑与心动并存，每一集都甜到掉牙！',
    category: 'comedy',
    tags: ['恋爱', '喜剧', '日常', '甜蜜'],
    status: '已完结',
    rating: 9.4,
    views: 10230000,
    likes: 845000,
    updatedAt: '2026-07-28',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `c4-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(6 - Math.floor(i / 8)).padStart(2, '0')}-${String(5 + (i % 25)).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-5',
    title: '校园风云',
    author: '张民浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20cover%2C%20students%20in%20school%20uniform%20walking%20through%20cherry%20blossom%20path%2C%20youth%20drama%20webtoon%20style%2C%20spring%20atmosphere%2C%20friendship%20theme%2C%20warm%20sunlight%2C%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-05&orientation=portrait',
    description: '转学生来到新学校，意外卷入校园帮派纷争。他用独特的方式化解矛盾，赢得尊重与友情。青春热血，笑中带泪的校园故事！',
    category: 'school',
    tags: ['校园', '青春', '友情', '成长'],
    status: '连载中',
    rating: 9.1,
    views: 7650000,
    likes: 512000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: `c5-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 5)).padStart(2, '0')}-${String(1 + (i % 30)).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-6',
    title: '鬼怪夜话',
    author: '韩智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%20art%2C%20ghostly%20figure%20in%20traditional%20Korean%20setting%2C%20dark%20eerie%20atmosphere%2C%20supernatural%20horror%20webtoon%20style%2C%20foggy%20night%20scene%2C%20creepy%20mansion%20background%2C%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-06&orientation=portrait',
    description: '每夜午夜，古老宅院中传来诡异声响。少女素敏搬入祖宅后，发现了一系列令人毛骨悚然的超自然现象。韩国传统鬼怪传说与现代恐怖完美融合！',
    category: 'horror',
    tags: ['恐怖', '鬼怪', '超自然', '悬疑'],
    status: '连载中',
    rating: 9.2,
    views: 6540000,
    likes: 428000,
    updatedAt: '2026-07-30',
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `c6-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(6 - Math.floor(i / 7)).padStart(2, '0')}-${String(15 + (i % 15)).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-7',
    title: '王的男人',
    author: '赵恩静',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20cover%2C%20handsome%20warrior%20in%20traditional%20Korean%20armor%2C%20ancient%20palace%20background%2C%20historical%20romance%20webtoon%20style%2C%20dramatic%20moonlight%20scene%2C%20rich%20traditional%20details%2C%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-07&orientation=portrait',
    description: '朝鲜时代，一名平民少年被选入宫中成为王的近侍。在波诡云谲的宫廷斗争中，他凭借忠诚与智慧周旋于各方势力之间，谱写了一段壮烈的历史传奇。',
    category: 'historical',
    tags: ['历史', '宫廷', '权谋', '传奇'],
    status: '已完结',
    rating: 9.7,
    views: 9890000,
    likes: 712000,
    updatedAt: '2026-06-15',
    chapters: Array.from({ length: 96 }, (_, i) => ({
      id: `c7-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(5 - Math.floor(i / 20)).padStart(2, '0')}-${String(10 + (i % 20)).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-8',
    title: '日常物语',
    author: '尹智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cozy%20home%20scene%20with%20cat%20and%20warm%20interior%2C%20healing%20everyday%20life%20webtoon%20style%2C%20soft%20sunlight%20through%20window%2C%20comforting%20atmosphere%2C%20clean%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-08&orientation=portrait',
    description: '独居女孩与她的三只猫的日常小确幸。没有惊天动地的剧情，只有温暖治愈的平凡生活。每一话都能让你会心一笑，感受生活中的小美好。',
    category: 'slice-of-life',
    tags: ['日常', '治愈', '猫咪', '温馨'],
    status: '连载中',
    rating: 9.3,
    views: 5430000,
    likes: 398000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 65 }, (_, i) => ({
      id: `c8-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 10)).padStart(2, '0')}-${String(5 + (i % 25)).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-9',
    title: '热血格斗',
    author: '朴正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fighting%20cover%2C%20martial%20artist%20in%20dynamic%20fighting%20pose%2C%20intense%20action%20webtoon%20style%2C%20explosive%20energy%20effects%2C%20urban%20street%20background%2C%20dramatic%20composition%2C%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-09&orientation=portrait',
    description: '地下格斗场的最强王者，为了守护重要的人而不断变强。每一场战斗都让人热血沸腾，拳拳到肉的真实打击感，让你感受格斗的魅力！',
    category: 'action',
    tags: ['格斗', '热血', '竞技', '成长'],
    status: '连载中',
    rating: 9.0,
    views: 8230000,
    likes: 589000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 60 }, (_, i) => ({
      id: `c9-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 9)).padStart(2, '0')}-${String(1 + (i % 28)).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: false,
  },
  {
    id: 'comic-10',
    title: '命运之轮',
    author: '宋惠乔',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20two%20people%20standing%20under%20cherry%20blossom%20tree%20at%20sunset%2C%20emotional%20romance%20webtoon%20style%2C%20melancholic%20atmosphere%2C%20beautiful%20scenery%2C%20dramatic%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-10&orientation=portrait',
    description: '两个被命运捉弄的人在时间的洪流中反复相遇又错过。前世今生的纠葛，跨越时空的爱情，让人泪目的虐心巨作。准备好纸巾，这将是一场心灵的洗礼。',
    category: 'drama',
    tags: ['虐心', '命运', '爱情', '轮回'],
    status: '连载中',
    rating: 9.8,
    views: 10890000,
    likes: 934000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 78 }, (_, i) => ({
      id: `c10-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 11)).padStart(2, '0')}-${String(8 + (i % 22)).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
  },
  {
    id: 'comic-11',
    title: '异世界食堂',
    author: '金美淑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20food%20cover%2C%20magical%20restaurant%20in%20fantasy%20world%2C%20delicious%20food%20illustration%2C%20cozy%20warm%20interior%2C%20whimsical%20webtoon%20style%2C%20glowing%20magical%20elements%2C%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-11&orientation=portrait',
    description: '女主穿越到异世界开了一家餐厅！用现代料理征服异世界居民的味蕾，同时收获友情与爱情。美食与冒险的完美结合，看完肚子会饿哦！',
    category: 'fantasy',
    tags: ['美食', '穿越', '异世界', '治愈'],
    status: '连载中',
    rating: 9.1,
    views: 6780000,
    likes: 445000,
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: `c11-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(7 - Math.floor(i / 8)).padStart(2, '0')}-${String(12 + (i % 18)).padStart(2, '0')}`,
    })),
    isHot: false,
    isNew: true,
  },
  {
    id: 'comic-12',
    title: '恋爱革命',
    author: '李娜英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20school%20cover%2C%20young%20couple%20in%20school%20uniform%20under%20starry%20sky%2C%20youthful%20romantic%20webtoon%20style%2C%20night%20scene%20with%20stars%2C%20tender%20atmosphere%2C%20manhwa%20cover%20design&width=400&height=560&seq=manhwa-cover-12&orientation=portrait',
    description: '平凡女高中生遇到校园王子后展开的爆笑恋爱攻势！谁说女生不能主动追爱？看女主用各种奇葩方式追求心上人，笑料百出又甜度满分！',
    category: 'romance',
    tags: ['校园', '恋爱', '喜剧', '青春'],
    status: '已完结',
    rating: 9.2,
    views: 9120000,
    likes: 667000,
    updatedAt: '2026-05-20',
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `c12-ch${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: `2026-${String(4 - Math.floor(i / 13)).padStart(2, '0')}-${String(15 + (i % 15)).padStart(2, '0')}`,
    })),
    isHot: true,
    isNew: false,
  },
];

export const userReviews: UserReview[] = [
  {
    id: 'review-1',
    userName: '漫画控小美',
    avatar: '',
    rating: 5,
    content: '这个网站真的太棒了！画质超清晰，加载速度也很快，而且完全免费！每天都要来看看有没有更新，已经成为我的日常习惯了！',
    date: '2026-08-01',
  },
  {
    id: 'review-2',
    userName: '深夜追漫人',
    avatar: '',
    rating: 5,
    content: '韩漫资源太全了，找了很久的几部冷门漫画在这里都找到了。分类也很清晰，找漫画特别方便。强烈推荐给所有韩漫爱好者！',
    date: '2026-07-28',
  },
  {
    id: 'review-3',
    userName: '漫画小王子',
    avatar: '',
    rating: 5,
    content: '更新速度很快，热门漫画基本都能同步更新。界面设计也很舒服，长时间看也不会觉得累。感谢提供这么好的平台！',
    date: '2026-07-25',
  },
  {
    id: 'review-4',
    userName: '甜甜的橘子',
    avatar: '',
    rating: 4,
    content: '内容很丰富，各类题材都有。特别喜欢恋爱和日常类漫画，每天睡前看几话，心情都会变好。希望能一直运营下去！',
    date: '2026-07-20',
  },
  {
    id: 'review-5',
    userName: '追风少年',
    avatar: '',
    rating: 5,
    content: '从其他平台过来的，没想到这里体验这么好！没有任何广告弹窗，阅读体验非常流畅。已经推荐给身边所有喜欢看漫画的朋友了。',
    date: '2026-07-15',
  },
  {
    id: 'review-6',
    userName: '猫小姐',
    avatar: '',
    rating: 5,
    content: '分类功能做得很好，可以按题材筛选。收藏功能也很实用，追漫神器！而且还经常上新，总是能发现好看的新漫画。',
    date: '2026-07-10',
  },
];

export const formatNumber = (num: number): string => {
  if (num >= 10000) {
    return `${(num / 10000).toFixed(1)}万`;
  }
  return num.toString();
};

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter((c) => c.category === categorySlug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getHotComics = (limit: number = 8): Comic[] => {
  return comics.filter((c) => c.isHot).slice(0, limit);
};

export const getNewComics = (limit: number = 8): Comic[] => {
  return comics.filter((c) => c.isNew).slice(0, limit);
};

export const getLatestComics = (limit: number = 12): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getRelatedComics = (comic: Comic, limit: number = 4): Comic[] => {
  return comics
    .filter((c) => c.id !== comic.id && c.category === comic.category)
    .slice(0, limit);
};